// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bid_limit_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BidKind } from "../../bfftypes/v1/bid_kind_pb";
import { file_bfftypes_v1_bid_kind } from "../../bfftypes/v1/bid_kind_pb";
import type { BidSegment } from "../../bfftypes/v1/bid_segment_pb";
import { file_bfftypes_v1_bid_segment } from "../../bfftypes/v1/bid_segment_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bid_limit_model.proto.
 */
export const file_bffuser_v1_bid_limit_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_bid_kind, file_bfftypes_v1_bid_segment, file_bfftypes_v1_side, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_decimal]);

/**
 * BidLimitCell represents a single (segment, area, side, kind) bid limit
 * entry. Presence semantics:
 *   - cell absent from the Get response: undecided
 *   - cell present, value field unset: "unlimited" (制限なし) explicit
 *   - cell present, value field set: limit value (price 円/kWh or quantity MW)
 *
 * @generated from message bffuser.v1.BidLimitCell
 */
export type BidLimitCell = Message<"bffuser.v1.BidLimitCell"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;

  /**
   * JEPX 非対応の沖縄 (AREA_CODE_OKINAWA = 10) を除外し、 北海道〜九州の
   * 1-9 のみ許可。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side side = 3;
   */
  side: Side;

  /**
   * @generated from field: bfftypes.v1.BidKind kind = 4;
   */
  kind: BidKind;

  /**
   * Decimal because price (円/kWh) and quantity (MW) are precision-
   * sensitive. Unset = "unlimited" explicit.
   *
   * @generated from field: optional google.type.Decimal value = 5;
   */
  value?: Decimal;
};

/**
 * Describes the message bffuser.v1.BidLimitCell.
 * Use `create(BidLimitCellSchema)` to create a new message.
 */
export const BidLimitCellSchema: GenMessage<BidLimitCell> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 0);

/**
 * BidLimitSegmentMeta carries the optimistic-lock baseline for one
 * segment's bid_limit_cell rows.
 *
 * Response-only message: no `(buf.validate.field).required = true` on
 * updated_at (protovalidate interceptor validates requests only).
 *
 * @generated from message bffuser.v1.BidLimitSegmentMeta
 */
export type BidLimitSegmentMeta = Message<"bffuser.v1.BidLimitSegmentMeta"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.BidLimitSegmentMeta.
 * Use `create(BidLimitSegmentMetaSchema)` to create a new message.
 */
export const BidLimitSegmentMetaSchema: GenMessage<BidLimitSegmentMeta> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 1);

/**
 * MarketOrderPolicyEntry is the per-(segment, area) market-order allow
 * boolean. bid_segment is constrained to SPOT_NORMAL (1) or INTRADAY (3).
 *
 * Response-only message: no `required = true` on updated_at.
 *
 * @generated from message bffuser.v1.MarketOrderPolicyEntry
 */
export type MarketOrderPolicyEntry = Message<"bffuser.v1.MarketOrderPolicyEntry"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;

  /**
   * 1-9 (沖縄除外、 see BidLimitCell.area_code).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bool allowed = 3;
   */
  allowed: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 5;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.MarketOrderPolicyEntry.
 * Use `create(MarketOrderPolicyEntrySchema)` to create a new message.
 */
export const MarketOrderPolicyEntrySchema: GenMessage<MarketOrderPolicyEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 2);

/**
 * BlockMandatoryPolicy is the organization-level toggle that, when
 * enabled, requires every cell of the SPOT_BLOCK matrix to be decided
 * before block orders can be created or submitted.
 *
 * Response-only message: no `required = true` on updated_at.
 *
 * @generated from message bffuser.v1.BlockMandatoryPolicy
 */
export type BlockMandatoryPolicy = Message<"bffuser.v1.BlockMandatoryPolicy"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.BlockMandatoryPolicy.
 * Use `create(BlockMandatoryPolicySchema)` to create a new message.
 */
export const BlockMandatoryPolicySchema: GenMessage<BlockMandatoryPolicy> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 3);

/**
 * FeeAutoConsiderPolicy is the per-(organization, segment) "手数料自動考慮"
 * (fee auto-consider) toggle. bid_segment is constrained to SPOT_NORMAL
 * (1) or INTRADAY (3): the spec has one spot flag (「手数料自動考慮
 * （スポット）」) and applies it to block bid creation as well
 * (bidding/spot-bidding.md AC-BSP-004b), so SPOT_BLOCK carries no toggle
 * of its own. Unlike MarketOrderPolicyEntry, this toggle has no area
 * dimension: spot and intraday are independent single flags.
 *
 * Response-only message: no `required = true` on updated_at.
 *
 * @generated from message bffuser.v1.FeeAutoConsiderPolicy
 */
export type FeeAutoConsiderPolicy = Message<"bffuser.v1.FeeAutoConsiderPolicy"> & {
  /**
   * @generated from field: bfftypes.v1.BidSegment bid_segment = 1;
   */
  bidSegment: BidSegment;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 4;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.FeeAutoConsiderPolicy.
 * Use `create(FeeAutoConsiderPolicySchema)` to create a new message.
 */
export const FeeAutoConsiderPolicySchema: GenMessage<FeeAutoConsiderPolicy> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 4);

/**
 * DefaultWithdrawOffsetSetting is the organization-singleton tenant-wide
 * default withdraw offset for intraday bids. ensure_exists default when
 * no row exists yet is DEFAULT_WITHDRAW_OFFSET_IMMEDIATE.
 *
 * Response-only message: no `required = true` on updated_at.
 *
 * @generated from message bffuser.v1.DefaultWithdrawOffsetSetting
 */
export type DefaultWithdrawOffsetSetting = Message<"bffuser.v1.DefaultWithdrawOffsetSetting"> & {
  /**
   * @generated from field: bffuser.v1.DefaultWithdrawOffset value = 1;
   */
  value: DefaultWithdrawOffset;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.DefaultWithdrawOffsetSetting.
 * Use `create(DefaultWithdrawOffsetSettingSchema)` to create a new message.
 */
export const DefaultWithdrawOffsetSettingSchema: GenMessage<DefaultWithdrawOffsetSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 5);

/**
 * BidTag is the organization-level tag attached to JEPX bids
 * (spot / intraday) for classification and reporting.
 *
 * @generated from message bffuser.v1.BidTag
 */
export type BidTag = Message<"bffuser.v1.BidTag"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Tag display name. 1-20 characters.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * UI 表示色 (4 値の色 variant)。 ecloud-designsystem Badge の色に対応。
   *
   * @generated from field: bffuser.v1.BidTagVariant variant = 3;
   */
  variant: BidTagVariant;

  /**
   * Display-order index within the organization's tag list.
   *
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * eauth member UUID string of the creator. Absent when not recorded.
   *
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * Last-updated timestamp; also serves as the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * eauth member UUID string of the last updater. Absent when not recorded.
   *
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;
};

/**
 * Describes the message bffuser.v1.BidTag.
 * Use `create(BidTagSchema)` to create a new message.
 */
export const BidTagSchema: GenMessage<BidTag> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bid_limit_model, 6);

/**
 * DefaultWithdrawOffset is the 5-step preset for how many minutes before
 * GC (Gate Closure) the intraday bid creation modal pre-fills the
 * auto-withdraw time (bidding/bid-limits.md §4, intraday-bidding.md
 * AC-BIN-004). It is only the modal's initial value: a bid whose own
 * withdraw time is unset has no auto-withdraw reserved, and this setting
 * is never applied to it at execution time. IMMEDIATE (直前, 0 分) pre-fills
 * a withdraw time equal to GC, which is an auto-withdraw at the same instant
 * as GC (AC-BIN-017); the other presets pre-fill GC minus N minutes.
 *
 * @generated from enum bffuser.v1.DefaultWithdrawOffset
 */
export enum DefaultWithdrawOffset {
  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_UNSPECIFIED = 0;
   */
  DEFAULT_WITHDRAW_OFFSET_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_IMMEDIATE = 1;
   */
  DEFAULT_WITHDRAW_OFFSET_IMMEDIATE = 1,

  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_30_MIN = 2;
   */
  DEFAULT_WITHDRAW_OFFSET_30_MIN = 2,

  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_1_HOUR = 3;
   */
  DEFAULT_WITHDRAW_OFFSET_1_HOUR = 3,

  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_1_HOUR_30_MIN = 4;
   */
  DEFAULT_WITHDRAW_OFFSET_1_HOUR_30_MIN = 4,

  /**
   * @generated from enum value: DEFAULT_WITHDRAW_OFFSET_2_HOUR = 5;
   */
  DEFAULT_WITHDRAW_OFFSET_2_HOUR = 5,
}

/**
 * Describes the enum bffuser.v1.DefaultWithdrawOffset.
 */
export const DefaultWithdrawOffsetSchema: GenEnum<DefaultWithdrawOffset> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bid_limit_model, 0);

/**
 * BidTagVariant is the tag "color" chosen on the bid-tag management screen.
 * bid_tag は severity の段階表示ではなく「色」概念であり (design は
 * セレクトを「タグ色」として 緑/橙/青/灰 の 4 値で提示、 docs/specs/settings
 * はバリアント ok/warn/info/neutral)、 共有の bfftypes.v1.LabelStatus
 * (5 段階 severity, NEGATIVE 含む) ではなくこの 4 値専用 enum を使う。
 *
 * @generated from enum bffuser.v1.BidTagVariant
 */
export enum BidTagVariant {
  /**
   * @generated from enum value: BID_TAG_VARIANT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 緑
   *
   * @generated from enum value: BID_TAG_VARIANT_OK = 1;
   */
  OK = 1,

  /**
   * 橙
   *
   * @generated from enum value: BID_TAG_VARIANT_WARN = 2;
   */
  WARN = 2,

  /**
   * 青
   *
   * @generated from enum value: BID_TAG_VARIANT_INFO = 3;
   */
  INFO = 3,

  /**
   * 灰
   *
   * @generated from enum value: BID_TAG_VARIANT_NEUTRAL = 4;
   */
  NEUTRAL = 4,
}

/**
 * Describes the enum bffuser.v1.BidTagVariant.
 */
export const BidTagVariantSchema: GenEnum<BidTagVariant> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bid_limit_model, 1);

